import { render, staticRenderFns } from "./Comunicado.vue?vue&type=template&id=7b074a53&scoped=true&lang=pug&"
import script from "./Comunicado.vue?vue&type=script&lang=js&"
export * from "./Comunicado.vue?vue&type=script&lang=js&"
import style0 from "./Comunicado.vue?vue&type=style&index=0&id=7b074a53&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b074a53",
  null
  
)

export default component.exports